import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import { Component } from 'react';

export default class App extends Component {
  constructor(props) {
    super(props);

    this.state = { 
      cells_t_minus_1: null,        // stores cells at Time: t-1
      cells_t: null,                // stores cells at Time: t  
      cells_seed: null,             // stores the initial cells seed  
      generation: 0,
      speed: 400,         // the speed at which new generations are created (in ms)
      max_width: 700,     // the grid will be constrained to this width & height - cell size is calculated based on this max width
      board_radius: 25,   // how many cells wide/high
      running: false,
      simulation_ended: false
    }

    this.compute_timeout = null;
    this.toggleRunning = this.toggleRunning.bind(this);
    this.restart = this.restart.bind(this);
    this.toggleSeedCell = this.toggleSeedCell.bind(this);
    this.loadSeed = this.loadSeed.bind(this);
    this.clearSeed = this.clearSeed.bind(this);
    this.resize = this.resize.bind(this);
  }

  golContainerWidth() {
    var gol_cont_elem = document.getElementById('gol-container');
    var padding_left = parseFloat(window.getComputedStyle(gol_cont_elem, null).getPropertyValue('padding-left').replace('px', ''));
    var padding_right = parseFloat(window.getComputedStyle(gol_cont_elem, null).getPropertyValue('padding-right').replace('px', ''));
    return padding_left + padding_right;
  }

  resize() {
    this.setState({ max_width: document.getElementById('gol-container').offsetWidth - this.golContainerWidth() }, () => {
      this.halt();
      this.initBoards();
    });
  }

  componentDidMount() {
    this.resize();
    window.addEventListener('resize', this.resize);
  }

  initBoards() {
    this.initGridDimensions(document.getElementById("gol"), this.state.max_width);
    this.initGridDimensions(document.getElementById("seed"), document.getElementById("seed_card_body").offsetWidth);

    var init_cells_t_minus_1 = this.defaultCellsOff(); 
    var init_cells_t = this.defaultCellsOff(); 
    var cells_seed = this.defaultCellsOff(); 

    // set an initial seed
    var start_x = parseInt(this.state.board_radius/2 - (this.state.board_radius/2)/2);
    for(var i = 0; i < this.state.board_radius / 2; i++) {
      var y = parseInt(this.state.board_radius/2);
      this.turnOn(init_cells_t_minus_1[start_x + i][y]);
      this.turnOn(init_cells_t_minus_1[start_x + i][y]);

      this.turnOn(cells_seed[start_x + i][y]);
      this.turnOn(cells_seed[start_x + i][y]);
    }

    // An initial configuration that is arguably somehwat interesting
    /*
    for(var i = 0; i < this.state.board_radius / 4; i++) {
      var x0 = this.state.board_radius - 2;
      var x1 = i;

      this.turnOn(init_cells_t_minus_1[x0][x1]);
      this.turnOn(init_cells_t_minus_1[x1][x0]);

      this.turnOn(cells_seed[x0][x1]);
      this.turnOn(cells_seed[x1][x0]);
    }
    */

    this.setState({ simulation_ended: false, generation: 0, cells_t_minus_1: init_cells_t_minus_1, cells_t: init_cells_t, cells_seed: cells_seed }, () => {
      this.run();
    });
  }

  halt() {
    this.setState({ running: false });
    clearTimeout(this.compute_timeout);
  }

  restart() {
    this.halt();
    this.loadSeed();
  }

  run() {
    this.compute();
    this.setState({ running: true });
  }

  toggleRunning() {
    this.state.running ? this.halt() : this.run();
  }

  initGridDimensions(grid_dom, width) {
    grid_dom.style.width = width + "px";
    grid_dom.style.height = width + "px";
  }

  defaultCellsOff() {
    var cells = new Array(this.state.board_radius);

    for(var x = 0; x < this.state.board_radius; x++) {
      cells[x] = new Array(this.state.board_radius);

      for(var y = 0; y < this.state.board_radius; y++) {
        cells[x][y] = { pos_x: x, pos_y: y, state: 'off'};
      }
    }
    return cells;
  }

  simulationHasEnded() {
    for( var x = 0; x < this.state.board_radius; x++ ) {
      for( var y = 0; y < this.state.board_radius; y++ ) {
        if( this.state.cells_t_minus_1[x][y].state != this.state.cells_t[x][y].state) {
          return false;
        }
      }
    }
    return true;
  }

  turnOn(cell) {
    cell.state = 'on';
  }

  turnOff(cell) {
    cell.state = 'off';
  }

  getNeighbors(cell){
    var neighbors = [];

    if(cell.pos_x - 1 >= 0) {
      if( cell.pos_y - 1 >= 0 ) {
        neighbors.push(this.state.cells_t_minus_1[cell.pos_x - 1][cell.pos_y - 1]);
      }

      neighbors.push(this.state.cells_t_minus_1[cell.pos_x - 1][cell.pos_y]);

      if( cell.pos_y + 1 < this.state.board_radius ) {
        neighbors.push(this.state.cells_t_minus_1[cell.pos_x - 1][cell.pos_y + 1]);
      }
    }

    if(cell.pos_x + 1 < this.state.board_radius) {
      if( cell.pos_y - 1 >= 0 ) {
        neighbors.push(this.state.cells_t_minus_1[cell.pos_x + 1][cell.pos_y - 1]);
      }

      neighbors.push(this.state.cells_t_minus_1[cell.pos_x + 1][cell.pos_y]);

      if( cell.pos_y + 1 < this.state.board_radius ) {
        neighbors.push(this.state.cells_t_minus_1[cell.pos_x + 1][cell.pos_y + 1]);
      }
    }
    
    if( cell.pos_y - 1 >= 0 ) {
      neighbors.push(this.state.cells_t_minus_1[cell.pos_x][cell.pos_y - 1]);
    }

    if(cell.pos_y + 1 < this.state.board_radius) {
      neighbors.push(this.state.cells_t_minus_1[cell.pos_x][cell.pos_y + 1]);
    }
    return neighbors;
  }

  compute() {
    // calculate the next generation
    for(var x = 0; x < this.state.board_radius; x++) {
      for(var y = 0; y < this.state.board_radius; y++) {
        var neighbors = this.getNeighbors(this.state.cells_t_minus_1[x][y]);
        var alive_neighbors = neighbors.filter(n => n.state == 'on').length;

        if(this.state.cells_t_minus_1[x][y].state == "on") {
          if(alive_neighbors == 2 || alive_neighbors == 3) {
            this.turnOn(this.state.cells_t[x][y]);
          }
          else { // > 3
            this.turnOff(this.state.cells_t[x][y]);
          }
        }
        else if(alive_neighbors == 3) {
          this.turnOn(this.state.cells_t[x][y]);
        }
      }
    }

    if(this.simulationHasEnded()) {
      this.halt();
      this.setState({ simulation_ended: true });
      return;
    }

    // turn on or off the old cells based on the new cells
    for(var x = 0; x < this.state.board_radius; x++) {
      for(var y = 0; y < this.state.board_radius; y++) {
        if(this.state.cells_t[x][y].state == 'on') {
          this.turnOn(this.state.cells_t_minus_1[x][y]);
        }
        else {
          this.turnOff(this.state.cells_t_minus_1[x][y]);
        }
      }
    }

    this.setState({ generation: this.state.generation + 1 });
    this.compute_timeout = setTimeout(function () { this.compute(); }.bind(this), this.state.speed);
  }

  toggleSeedCell(x, y) {
    if(this.state.running) {
      this.halt();
    }

    var seed = this.state.cells_seed;

    if(this.state.cells_seed[x][y].state == 'off') {
      this.turnOn(seed[x][y]);
    }
    else {
      this.turnOff(seed[x][y]);
    }
    this.setState({ cells_seed: seed });
  }

  loadSeed() {
    this.halt();

    var cells = new Array(this.state.board_radius);
    for(var x = 0; x < this.state.board_radius; x++) {
      cells[x] = new Array(this.state.board_radius);

      for(var y = 0; y < this.state.board_radius; y++) {
        cells[x][y] = { pos_x: x, pos_y: y, state: this.state.cells_seed[x][y].state};
      }
    }

    this.setState({ simulation_ended: false, cells_t_minus_1: cells, cells_t: this.defaultCellsOff(), generation: 0 }, () => {
      this.run();
    });
  }

  clearSeed() {
    this.halt();

    var seed = this.state.cells_seed;
    for(var x = 0; x < this.state.board_radius; x++) {
      for(var y = 0; y < this.state.board_radius; y++) {
        this.turnOff(seed[x][y]);
      }
    }

    this.setState({ cells_seed: seed });
  }

  render() {
    var gol_cell_width = this.state.max_width / this.state.board_radius;
    var seed_cell_size = this.state.cells_seed ? Math.floor(document.getElementById("seed_card_body").offsetWidth / this.state.board_radius) : 0;

    return (
      <div className="container-fluid">
        <div className="row mt-5">
          <div className="col header text-center">
            <h2>Game Of Life Simulator</h2>

            <div className="mb-3">Generation: {this.state.generation} / Speed: {this.state.speed}ms / Radius: {this.state.board_radius} cells</div>

            <div className="mb-3">
              <button className="btn btn-danger" onClick={this.toggleRunning}>
                { this.state.running ? "Halt" : "Resume" } 
              </button>

              <button className="ml-2 btn btn-success" onClick={this.restart}>Restart</button>

              {this.state.simulation_ended ? (
                <span className="text-light ml-2">Simulation Ended</span>
              ) : ''}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-lg-3 mb-5 mb-lg-0">
            <div className="card bg-light">
              <div className="card-header">Initial Seed</div>
              <div className="card-body">
                <div id="seed_card_body" className="mb-2">
                  Click the cells below to edit the seed, and then click Load 
                </div>
                <div id="seed">
                  {this.state.cells_seed ? (
                    this.state.cells_seed.map((cell_x, x_index) => {
                      return cell_x.map((cell_y, y_index) => {
                        return <div key={'cell_' + x_index + y_index} onClick={() => this.toggleSeedCell(x_index, y_index)} className={cell_y.state == 'off' ? 'cell off' : 'cell on'} style={{width: seed_cell_size, height: seed_cell_size, left: x_index*seed_cell_size, top: y_index*seed_cell_size}}></div>
                      })
                    })
                  ) : null}
                </div>

                <button className="btn btn-light mt-2 float-left" onClick={this.clearSeed}>Clear</button>
                <button className="btn btn-primary mt-2 float-right" onClick={this.loadSeed}>Load</button>
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-4 mx-auto text-center mb-5 mb-lg-0" id="gol-container">
            <div id="gol">
              {this.state.cells_t_minus_1 ? (
                this.state.cells_t_minus_1.map((cell_x, x_index) => { 
                  return cell_x.map((cell_y, y_index) => {
                    return <div key={'cell_' + x_index + y_index} className={cell_y.state == 'off' ? 'cell off' : 'cell on'} style={{width: gol_cell_width, height: gol_cell_width, left: x_index*gol_cell_width, top: y_index*gol_cell_width}}></div>
                  })
                })
              ) : null}
            </div>
          </div>

          <div className="col-12 col-lg-3">
            <div className="card bg-light mb-2">
              <div className="card-header">Rules</div>
              <div className="card-body">
                <p className="card-text">A cell can be either alive (colored) or dead (white)</p>
                <p className="card-text">During each generation the state of the cell is computed from the following rules:</p>
                <ol>
                  <li>If the cell is alive and has 2 or 3 alive neighboring cells, it stays alive</li>
                  <li>If the cell is alive and has more than 3 alive neighboring cells, it dies</li>
                  <li>If the cell is dead and has 3 alive neighboring cells, it becomes alive</li>
                </ol>
                <p className="card-text">
                  <a href="https://en.wikipedia.org/wiki/Conway%27s_Game_of_Life" target="_blank">Game of Life on Wikipedia</a>
                </p>

                <p className="card-text">
                  Programming credit: Blake Miller (@newmicro)<br />
                  <a href="https://blakescreations.com" target="_blank">blakescreations.com</a> | <a href="https://twitter.com/newmicro2" target="_blank">Twitter</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}